'use client';

export { default } from './Divider';
export { default as dividerClasses } from './dividerClasses';
export * from './dividerClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/Divider/index.js
// module id = 450
// module chunks = 22